<template>
  <div class="chart-container">
    <div v-if="loading" class="loader-wrapper">
      <loader />
    </div>
    <template v-else>
      <slot v-if="noData" name="no-data">
        <div class="no-chart-data">
          Нет данных за выбранный период
        </div>
      </slot>
      <slot v-else name="chart"></slot>
    </template>
  </div>
</template>

<script>
  import Loader from '@/components/loader/Loader.vue'

  export default {
    name: 'ChartContainer',
    components: { Loader },
    props: {
      loading: { type: Boolean, default: false },
      noData: { type: Boolean, default: false },
    },
  }
</script>

<style scoped lang="less">
@import '@/assets/styles/statistic.less';
</style>
